export default __webpack_public_path__ + "static/media/comp-logo.9c241cec.svg";